import React from 'react'

export default function SelectFeedbackType() {
  return (
    <div>SelectFeedbackType</div>
  )
}
